export default [
  "#63B3ED",
  "#C6F6D5",
  "#F6E05E",
  "#2A4365",
  "#9B2C2C",
  "#4FD1C5",
  "#434190",
  "#ED64A6",
  "#DD6B20",
  "#276749",
  "#FC8181",
  "#FBD38D",
  "#D6BCFA",
  "#975A16",
  "#F8BBD0",
  "#283593",
  "#B2DFDB",
  "#C6FF00",
  "#AA2Bd3",
  "#01579B",
  "#B39DDB",
  "#FF5252",
  "#004D40",
  "#DCEDC8",
  "#EF6C00",
  "#8D6E63",
  "#9FA8DA",
  "#263238",
  "#FFF176",
  "#880E4F",
  "#2E7D32",
  "#FFB74D",
  "#D500F9",
  "#26A69A",
  "#AED581",
  "#FBC02D",
  "#0097A7",
  "#D84315",
  "#6D4C41",
  "#0D47A1",
  "#a0aec0", //Cor do intervalo deve ser a ultima do pallete
];
